// File: src/layouts/SidebarLink.tsx
import React, {JSX} from 'react';
import { NavLink } from 'react-router-dom';
import { useDirection } from '../hooks/useDirection';

interface SidebarLinkProps {
  to: string;
  icon: JSX.Element;
  label: string;
}

const SidebarLink: React.FC<SidebarLinkProps> = ({ to, icon, label }) => {
  const { isRTL, direction } = useDirection();

  return (
    <NavLink
      to={to}
      end // Use 'end' to prevent matching parent routes, e.g., for '/app'
      className={({ isActive }) =>
        `flex flex-col items-center justify-center p-3 rounded-lg w-full transition-colors duration-200
         ${
           isActive
             ? 'bg-primary-lightest text-primary-dark'
             : 'text-neutral-dark hover:bg-neutral-lightest'
         }`
      }
      dir={direction}
    >
      {/* The icon is rendered here. Its size and color are passed from the parent. */}
      {icon} 
      {/* MODIFIED: Increased font size to text-lg and adjusted top margin, added RTL text alignment */}
      <span className={`text-x1 text-md font-medium mt-2 ${isRTL ? 'text-center' : 'text-center'}`}>{label}</span>
    </NavLink>
  );
};

export default SidebarLink;